import React from 'react';
import classNames from 'classnames';
import nbcNewsLogo from 'assets/icons/nbc-logo-with-text.svg';
import styles from './styles.module.scss';

/**
 *
 * @param {object} props
 * @param {React.ReactNode} props.videoComponent The video component
 * @param {boolean} props.isClosing If the modal is in the process of the closing sequence
 * @param {Function} props.closeOverlay Callback to close the overlay
 * @param {boolean} props.isVisible If the modal should be rendered
 */
export const VideoOverlay = ({
  videoComponent, isClosing, isVisible, closeOverlay,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={classNames(styles.videoOverlay, {
        [styles.closing]: isClosing,
      })}
      data-testid="video-overlay"
      onClick={closeOverlay}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') closeOverlay();
        if (e.key === 'Escape') closeOverlay();
      }}
    >
      <img src={nbcNewsLogo} alt="NBC News" className={styles.overlayLogo} />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Video player overlay"
        data-testid="video-modal"
        className={styles.videoModal}
      >
        {videoComponent}
      </div>
    </div>
  );
};
